function showSearch() {
  jQuery('#header__bottom').addClass('header__bottom--search');
  jQuery('#mobile-navigation').addClass('site-search');
  jQuery('.header__toggle-search-icon').addClass('hide');
  jQuery('#search-form-1').focus();
}

function hideSearch() {
  jQuery('#header__bottom').removeClass('header__bottom--search');
  jQuery('#mobile-navigation').removeClass('site-search');
  jQuery('.header__toggle-search-icon').removeClass('hide');
}